// @flow
import * as React from "react";
import CloseIcon from "./Close";
import InfoIcon from "./Info";
import WarningIcon from "./Warning";
import Kuchka from "./Kuchka";
import Forex from "./Forex";
import SideArrow from "./SideArrow";

export type IconProps = {
  width?: string,
  height?: string,
  fill?: string,
  className?: string,
  onClick?: () => void
};

type Props = {
  ...IconProps,
  viewBox: string,
  children: React.Node,
  style?: { [key: string]: string | number }
};

export default function Icon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={props.viewBox}
      fill={props.fill}
      width={props.width}
      height={props.height}
      className={props.className}
      style={props.style}
      onClick={props.onClick}
    >
      {props.children}
    </svg>
  );
}

export { CloseIcon, InfoIcon, WarningIcon, Kuchka, Forex, SideArrow };



// WEBPACK FOOTER //
// ./src/components/Icons/index.js